import type { ForceLogoProps } from "../types";

/**
 * LIのForceロゴアイコン
 */
export function ForceLogoLI({ size = 36, ...props }: ForceLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2656 23.7109V12.2891H14.6875V21.7109H19.3203V23.7109H12.2656Z"
        fill="#0B1D12"
      />
      <path
        d="M21.3125 23.7109V12.2891H23.7344V23.7109H21.3125Z"
        fill="#0B1D12"
      />
    </svg>
  );
}
